var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlinePreviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 5.625,
    stroke: "#1B51A4",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_838_1872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 7.55566C8.84312 7.55566 8.44446 7.95433 8.44446 8.44455V15.5557C8.44446 16.0459 8.84312 16.4446 9.33335 16.4446H11.4018C11.7026 16.4446 11.89 16.0995 11.7785 15.8201C11.7175 15.6672 11.5738 15.5557 11.4092 15.5557H9.73335C9.51243 15.5557 9.33335 15.3766 9.33335 15.1557V8.84455C9.33335 8.62364 9.51243 8.44455 9.73335 8.44455H12.0445C12.2654 8.44455 12.4445 8.62364 12.4445 8.84455V10.2668C12.4445 10.4877 12.6235 10.6668 12.8445 10.6668H14.2667C14.4876 10.6668 14.6667 10.8459 14.6667 11.0668L14.6667 11.2668C14.6667 11.4877 14.8458 11.6668 15.0667 11.6668C15.0966 11.6668 15.1263 11.6668 15.1556 11.6668C15.3765 11.6668 15.5556 11.4877 15.5556 11.2668V10.2223L12.8889 7.55566H9.33335ZM14.6667 12.4446C13.4222 12.4446 12.4445 13.4223 12.4445 14.6668C12.4445 15.9112 13.4222 16.889 14.6667 16.889C15.1111 16.889 15.5559 16.7553 15.9115 16.5331L16.7109 17.3334L17.3333 16.711L16.533 15.9116C16.7552 15.556 16.8889 15.1112 16.8889 14.6668C16.8889 13.4223 15.9111 12.4446 14.6667 12.4446ZM14.6667 13.3334C15.4222 13.3334 16 13.9112 16 14.6668C16 15.4223 15.4222 16.0001 14.6667 16.0001C13.9111 16.0001 13.3333 15.4223 13.3333 14.6668C13.3333 13.9112 13.9111 13.3334 14.6667 13.3334Z",
    fill: "#1B51A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_838_1872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white",
    transform: "translate(6.66663 6.66675)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinePreviewIcon);
export default __webpack_public_path__ + "static/media/outline-preview-icon.3f24943b0315ac99c181190fb616ae3f.svg";
export { ForwardRef as ReactComponent };